import CitySEOHead from "@/components/feature/CitySEOHead";
import NormanHeroSection from "./components/HeroSection";
import NormanStickyNav from "./components/StickyNav";
import NormanProcessingTimeSection from "./components/ProcessingTimeSection";
import NormanServicesSection from "./components/ServicesSection";
import NormanLocalAreaSection from "./components/LocalAreaSection";
import NormanTravelTimingSection from "./components/TravelTimingSection";
import NormanDestinationsSection from "./components/DestinationsSection";
import NormanTestimonialsSection from "./components/TestimonialsSection";
import NormanAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import NormanComparisonSection from "./components/ComparisonSection";
import NormanMistakesSection from "./components/MistakesSection";
import NormanHowItWorksSection from "./components/HowItWorksSection";
import NormanFAQSection, { faqs } from "./components/FAQSection";
import NormanHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import NormanFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for Norman travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Norman with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance for Norman residents with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "OU Study Abroad Passport Processing", description: "Expedited passport coordination for OU students departing for semester abroad programs in Jerusalem, Rome, London, and beyond." },
];

export default function NormanPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Norman"
        state="Oklahoma"
        stateAbbr="OK"
        route="/cities/norman"
        title="Emergency Passport Norman, OK — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Norman, OK — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving OU students, faculty, Norman families, and OU Health professionals."
        geoPlacename="Norman, Oklahoma"
        geoPosition="35.2226;-97.4395"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Oklahoma"
        statePageRoute="/states/oklahoma"
      />
      <NormanHeroSection />
      <NormanStickyNav />
      <NormanProcessingTimeSection />
      <NormanServicesSection />
      <NormanLocalAreaSection />
      <NormanTravelTimingSection />
      <NormanDestinationsSection />
      <NormanTestimonialsSection />
      <NormanAcceptanceFacilitiesSection />
      <NormanComparisonSection />
      <NormanMistakesSection />
      <NormanHowItWorksSection />
      <NormanFAQSection />
      <NormanHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/norman" state="OK" />
      <NormanFinalCTA />
    </div>
  );
}